<template>
  <el-button
    :type="btnType"
    :loading="loading"
    v-bind="$attrs"
    @click.stop="submitRequest"
    ><slot
  /></el-button>
</template>

<script>
export default {
  name: 'loadingBtn',
  data() {
    return {
      loading: false,
    }
  },
  props: {
    btnType: {
      type: String,
      default: 'primary',
    },
  },
  methods: {
    changeLoading() {
      this.loading = !this.loading
    },
    submitRequest() {
      if (this.loading) return
      this.$emit('request', this.changeLoading)
    },
  },
}
</script>

<style scoped></style>
